"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lipari": {
    "848d2891": [{
      "hkey": "7b13ddd8",
      "slug": "acquacalda",
      "name": "Acquacalda",
      "primary": true,
      "skipSearch": false
    }],
    "acquacalda": [{
      "hkey": "7b13ddd8",
      "slug": "acquacalda",
      "name": "Acquacalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "3d08db5c": [{
      "hkey": "e34af2df",
      "slug": "isola-di-alicudi",
      "name": "Isola di Alicudi",
      "primary": true,
      "skipSearch": false
    }],
    "alicudi": [{
      "hkey": "e34af2df",
      "slug": "isola-di-alicudi",
      "name": "Isola di Alicudi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "400b38ab": [{
      "hkey": "9c5d85f3",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "skipSearch": false
    }],
    "canneto": [{
      "hkey": "9c5d85f3",
      "slug": "canneto",
      "name": "Canneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "bf96fe59": [{
      "hkey": "657caa2d",
      "slug": "isola-di-filicudi",
      "name": "Isola di Filicudi",
      "primary": true,
      "skipSearch": false
    }],
    "filicudi": [{
      "hkey": "657caa2d",
      "slug": "isola-di-filicudi",
      "name": "Isola di Filicudi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "426cb3e3": [{
      "hkey": "4e26636d",
      "slug": "filicudi-porto",
      "name": "Filicudi Porto",
      "primary": true,
      "skipSearch": false
    }],
    "filicudi-porto": [{
      "hkey": "4e26636d",
      "slug": "filicudi-porto",
      "name": "Filicudi Porto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-filicudi"
    }],
    "d0c52223": [{
      "hkey": "de95b908",
      "slug": "isola-di-stromboli",
      "name": "Isola di Stromboli",
      "primary": true,
      "skipSearch": false
    }],
    "ginostra": [{
      "hkey": "de95b908",
      "slug": "isola-di-stromboli",
      "name": "Isola di Stromboli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lipari"
    }],
    "dc793917": [{
      "hkey": "67f3d7f7",
      "slug": "lami",
      "name": "Lami",
      "primary": true,
      "skipSearch": false
    }],
    "lami": [{
      "hkey": "67f3d7f7",
      "slug": "lami",
      "name": "Lami",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "b754bf2e": [{
      "hkey": "acfb6db2",
      "slug": "isola-di-panarea",
      "name": "Isola di Panarea",
      "primary": true,
      "skipSearch": false
    }],
    "panarea": [{
      "hkey": "acfb6db2",
      "slug": "isola-di-panarea",
      "name": "Isola di Panarea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85bd0d2a": [{
      "hkey": "faf3a94d",
      "slug": "pianoconte",
      "name": "Pianoconte",
      "primary": true,
      "skipSearch": false
    }],
    "pianoconte": [{
      "hkey": "faf3a94d",
      "slug": "pianoconte",
      "name": "Pianoconte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "b362b98b": [{
      "hkey": "dba7327f",
      "slug": "pirrera",
      "name": "Pirrera",
      "primary": true,
      "skipSearch": false
    }],
    "pirrera": [{
      "hkey": "dba7327f",
      "slug": "pirrera",
      "name": "Pirrera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "b4dff274": [{
      "hkey": "4eb23073",
      "slug": "quattropani",
      "name": "Quattropani",
      "primary": true,
      "skipSearch": false
    }],
    "quattropani": [{
      "hkey": "4eb23073",
      "slug": "quattropani",
      "name": "Quattropani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "isola-di-lipari"
    }],
    "d0dfbc82": [{
      "hkey": "a5bcf1d6",
      "slug": "lipari",
      "name": "Lipari",
      "primary": true,
      "skipSearch": false
    }],
    "salina": [{
      "hkey": "a5bcf1d6",
      "slug": "lipari",
      "name": "Lipari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2f7b3fd": [{
      "hkey": "84987998",
      "slug": "isola-di-lipari",
      "name": "Isola di Lipari",
      "primary": true,
      "skipSearch": false
    }],
    "serra": [{
      "hkey": "84987998",
      "slug": "isola-di-lipari",
      "name": "Isola di Lipari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lipari"
    }],
    "4feae058": [{
      "hkey": "de95b908",
      "slug": "isola-di-stromboli",
      "name": "Isola di Stromboli",
      "primary": true,
      "skipSearch": false
    }],
    "stromboli": [{
      "hkey": "de95b908",
      "slug": "isola-di-stromboli",
      "name": "Isola di Stromboli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e967c99d": [{
      "hkey": "d054032f",
      "slug": "isola-di-vulcano",
      "name": "Isola di Vulcano",
      "primary": true,
      "skipSearch": false
    }],
    "vulcano": [{
      "hkey": "d054032f",
      "slug": "isola-di-vulcano",
      "name": "Isola di Vulcano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;